import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Swap from '../src/components/Swap/Swap'
import Farms from '../src/components/farms/farms';
import Pools from './components/pools/pools';
import Info from './components/info/info';
import Ifo from './components/ifo/ifo';
import Voting from './components/voting/voting';
import ProposalDetail from './components/proposal-detail/proposal-detail';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
return (
	<div className="main-wrapper">
		<Router>
			<Switch>
				<Route path="/" exact name="Swap Page" component={Swap} />
				<Route path="/farms" exact name="Farms Page" component={Farms} />
				<Route path="/pools" exact name="Pools Page" component={Pools} />
				<Route path="/info" exact name="Info Page" component={Info} />
				<Route path="/ifo" exact name="Ifo Page" component={Ifo} />
				<Route path="/voting" exact name="Voting Page" component={Voting} />
				<Route path="/proposal-detail" exact name="Info Page" component={ProposalDetail} />
			</Switch>
		</Router>
	</div>
);
}

export default App;
